export function uppercaseFirstLetter(str: string) {
  if (str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const isImage = (str: string | undefined | null) => {
  return str && new RegExp(/\.(jpeg|jpg|gif|png|svg)$/).test(str);
};
